module.exports = __webpack_public_path__ + "img/logoUcraft.a4d6abbd.png";